export default __webpack_public_path__ + "static/media/login-background.f0e4e34d.png";